import { Link } from 'react-router-dom';

import { ROUTE_PATHS } from 'src/shared/config/routes';
import { ProductLifecycleStage } from 'src/shared/types/product';

import { ButtonV2, Typography } from 'src/shared/components/ui';

import getProductActions from '../utils/getProductActions';

interface ProductActionsCellProps {
  id: string;
  lifecycle: ProductLifecycleStage[];
}

/**
 * Shortcuts to the product page where the action is completed: ordering
 * needs an address and quantity, and buying a sample needs a chosen quote.
 */
const ProductActionsCell: React.FC<ProductActionsCellProps> = ({
  id,
  lifecycle
}) => {
  const actions = getProductActions(lifecycle);
  const productPath = `${ROUTE_PATHS.PRODUCTS}/${id}`;
  const quotesPath = `${productPath}?tab=quotes`;
  const orderPath = `${productPath}?newOrder=true`;

  if (actions.length === 0) {
    return (
      <div className="h-16 flex items-center">
        <Typography variant="body-1" weight="medium">
          -
        </Typography>
      </div>
    );
  }

  return (
    <div className="h-16 flex items-center gap-2">
      {actions.includes('reorder') && (
        <ButtonV2
          as={Link}
          to={orderPath}
          href={orderPath}
          size="sm"
          color="tertiary"
        >
          Reorder
        </ButtonV2>
      )}
      {actions.includes('place-order') && (
        <ButtonV2
          as={Link}
          to={orderPath}
          href={orderPath}
          size="sm"
          color="tertiary"
        >
          Place order
        </ButtonV2>
      )}
      {actions.includes('purchase-sample') && (
        <ButtonV2
          as={Link}
          to={quotesPath}
          href={quotesPath}
          size="sm"
          color="tertiary"
        >
          Purchase sample
        </ButtonV2>
      )}
    </div>
  );
};

export default ProductActionsCell;
